import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="relative overflow-hidden aspect-[16/10]">
        <img
          src={article.coverImage}
          alt={article.title}
          title={`${article.title} - 91自拍论坛`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-3 left-3">
          <span className="px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">
            {article.category === 'composition' ? '自拍构图' : article.category === 'lighting' ? '光线运用' : article.category === 'editing' ? '后期修图' : article.category === 'sharing' ? '达人分享' : '器材推荐'}
          </span>
        </div>
      </div>
      <div className="p-4 md:p-5">
        <h3 className="font-heading text-base md:text-lg text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
          {article.title}
        </h3>
        <p className="text-sm text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-400">
          <div className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <div className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-user-line text-xs"></i>
              </div>
              {article.author}
            </span>
            <span className="flex items-center gap-1">
              <div className="w-3.5 h-3.5 flex items-center justify-center">
                <i className="ri-time-line text-xs"></i>
              </div>
              {article.readTime}
            </span>
          </div>
          <span>{article.date}</span>
        </div>
      </div>
    </Link>
  );
}